import { SvgIcon } from '@mui/material';

export function ChevronRightSmallIcon(props) {
	return (
		<SvgIcon width="6" height="8" viewBox="0 0 6 8" fill="none" {...props}>
			<path
				d="M1.5 7L4.5 4.01904L1.5 1"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
			/>
		</SvgIcon>
	);
}
